import { Outlet } from "react-router-dom";
import { TofuSidebar } from "@components/ui_v2/TofuSidebar";
import { NavbarTofuMobile } from "@components/ui_v2/NavbarTofuMobile";
import { OnboardingWizardLayout } from "@components/ui_v2/OnboardingWizardLayout";

/**
 * Ancho de la columna de captura. El expediente pide más que el tofu porque sus pantallas llevan
 * la barra de secciones (`TabBofuV2`) y listas de documentos, no un formulario de pocos campos.
 */
const MAX_CONTENT_WIDTH = { md: 700, lg: 800 };

interface Props {
  /** `md` para el onboarding/tofu, `lg` para el expediente/bofu. */
  size: keyof typeof MAX_CONTENT_WIDTH;
}

const TofuLayout = ({ size }: Props) => (
  <OnboardingWizardLayout
    sidebar={<TofuSidebar />}
    mobileNavbar={<NavbarTofuMobile />}
    maxContentWidth={MAX_CONTENT_WIDTH[size]}
  >
    <Outlet />
  </OnboardingWizardLayout>
);

export default TofuLayout;
